import { notification } from "antd";
import { toast } from "react-toastify";
import { useNavigate, NavigateFunction } from "react-router-dom";

// Helper
import { useLoading } from "../context/common/CommonContext";
import { clearLocalStorage } from "../helpers";
// import { refreshToken } from "../http/auth";

// export const handleUnAuthorizeError = async (redirect: NavigateFunction) => {
//   const res = await refreshToken(localStorage.getItem("refresh"));
//   if (res.status === 200) {
//     setLocalStorage("token", res.data.access);
//     return res.status;
//   } else {
//     localStorage.clear();
//     redirect("/");
//     return res.status;
//   }
// };

export const handle400Error = (data: any) => {
  delete data["data"];
  delete data["success"];
  notification.error({
    message: "Error",
    description: data[Object.keys(data)[0]],
    duration: 0,
  });
};

export const handleLogout = (redirect: NavigateFunction) => {
  clearLocalStorage();
  redirect("/login");
};

export const handleNoPermissoin = (redirect: NavigateFunction) => {
  redirect("/");
};

export const useApiCall = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();

  const call = async (
    apiCall: () => Promise<any>,
    onSuccess: (data: any) => void,
    onError?: (err?: any) => void,
    successLoader: boolean = true,
    showLoader: boolean = true // set false for silent background calls (e.g. polling) to avoid flickering the full-page loader
  ) => {
    try {
      if (showLoader) setLoading(true); // Open loader for every API request
      const res = await apiCall();
      if (showLoader) setLoading(false); // Close loader on every API response complete
      if (!res) {
        // The service call caught an axios rejection with no `response`
        // (network error, timeout, or request cancellation) and returned
        // undefined. Destructuring that below would throw a TypeError that
        // got swallowed by the generic catch block, hiding the real cause.
        console.error(
          "API call resolved without a response (network error, timeout, or cancellation)."
        );
        notification.error({
          message: "Error",
          description:
            "Network error — please check your connection and try again",
          duration: 0,
        });
        if (onError) onError();
        return;
      }
      const { data, status } = res;
      switch (status) {
        case 200:
        case 201:
        case 204:
          if (successLoader) {
            toast.success(data.message || "Success");
          }
          onSuccess(data);
          break;
        case 400:
          handle400Error(data);
          if (onError) onError(data);
          break;
        case 401:
          if (onError) {
            onError(data);
          } else {
            handleLogout(navigate);
          }
          // In Future case
          // handleUnAuthorizeError(navigate).then((status) => {
          //   if (status === 200) apiCall();
          //   if (onError) {
          //     onError(data);
          //   } else {
          //     handle400Error(data);
          //   }
          // });
          break;
        case 403:
          notification.error({
            message: "Forbidden",
            description: data.detail,
            duration: 0,
          });
          handleNoPermissoin(navigate);
          break;

        case 413:
          notification.error({
            message: "File too large",
            description:
              "The Excel file exceeds the 25 MB limit. Please upload a smaller file.",
            duration: 0,
          });
          handleNoPermissoin(navigate);
          break;

        case 404:
          notification.error({
            message: "Not Found",
            description: data.detail,
            duration: 0,
          });
          break;

        default:
          notification.error({
            message: "Error",
            description: data.message,
            duration: 0,
          });
          if (onError) onError(data);
          break;
      }
    } catch (err) {
      if (showLoader) setLoading(false); // Close loader on every API errors.
      console.error(err); // For debug
      notification.error({
        message: "Error",
        description: "Something went wrong",
        duration: 0,
      });
      if (onError) onError();
    }
  };

  return { call };
};
